// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/1f801b2e69a0f87c1716.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"fec8054a6785bb12efdf","126":"0301e10cb1e4749b9ff7","127":"fa66ee418c76cdc4666d"}[chunkId] + ".chunk.js";
};